import { IClassname } from '@/lib/shared/model/classname';

export const Dryer = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14249_7770)">
        <path
          d="M15.2811 30.3762H3.58021C3.07182 30.3762 2.58425 30.1743 2.22477 29.8148C1.86529 29.4553 1.66333 28.9677 1.66333 28.4593V3.53992C1.66333 3.03154 1.86529 2.54396 2.22477 2.18449C2.58425 1.825 3.07182 1.62305 3.58021 1.62305H24.6658C25.1742 1.62305 25.6618 1.825 26.0213 2.18449C26.3807 2.54396 26.5826 3.03154 26.5826 3.53992V14.5221"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.49707 5.45703H9.33082"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.66333 9.29102H26.5826"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5397 18.7217C18.3741 20.6642 18.3741 22.6067 19.5397 24.5492C20.7052 26.4917 20.7052 28.4342 19.5397 30.3767"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.4919 18.7217C23.3263 20.6642 23.3263 22.6067 24.4919 24.5492C25.6573 26.4917 25.6573 28.4342 24.4919 30.3767"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.4637 18.7217C28.2982 20.6642 28.2982 22.6067 29.4637 24.5492C30.6292 26.4917 30.6292 28.4342 29.4637 30.3767"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1231 26.5431C10.4178 26.5431 7.41406 23.5394 7.41406 19.8341C7.41406 16.1287 10.4178 13.125 14.1231 13.125C15.7626 13.125 17.2647 13.7131 18.43 14.6897"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0399 5.77665C15.8636 5.77665 15.7205 5.63362 15.7205 5.45717C15.7205 5.28073 15.8636 5.1377 16.0399 5.1377"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0398 5.77665C16.2163 5.77665 16.3593 5.63362 16.3593 5.45717C16.3593 5.28073 16.2163 5.1377 16.0398 5.1377"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.7904 5.77665C21.6141 5.77665 21.4709 5.63362 21.4709 5.45717C21.4709 5.28073 21.6141 5.1377 21.7904 5.1377"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.7905 5.77665C21.967 5.77665 22.11 5.63362 22.11 5.45717C22.11 5.28073 21.967 5.1377 21.7905 5.1377"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14249_7770">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
